import { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserCapability } from "./ConstantReducerProvider";
import DropDown from "../ReusableComponents/DropDown";
import { BindAPI } from "../services/APIConnection";
import ReportTableRow from "./ReportTableRow";

const ReportRowRowPage = ({
  title,
  tableHeight,
  handleExport,
  handlePDF,
  header,
  records,
  handleAction,
  handleSchoolView,
  isGenderBased,
}) => {
  //search state start
  const [searchInput, setSearchInput] = useState("");
  const [searchData, setSearchData] = useState([]);

  // loader state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (records) {
      setSearchData(records);
    }
  }, [records]);

  //next page state start
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState("");
  //next page state end

  const [bindDDValues, setBindDDValues] = useState([]);

  const systemSettingsData = async () => {
    const response = await BindAPI("SystemSettingsAPI/BindSystemSettings");
    const rowsPerPageFromApi = response.data.Table[0].NoofRowsPerPage;
    setItemsPerPage(rowsPerPageFromApi);
  };

  const getDDValues = async () => {
    try {
      const response = await BindAPI("MasterDataAPI/BindDDValues");
      const resultdata = response.data.Table;

      if (resultdata.length > 0) {
        const religionDD = resultdata.map((m) => ({
          value: m.NoOfRecords,
          label: m.NoOfRecords,
        }));
        setBindDDValues(religionDD);
      } else {
        setBindDDValues([]);
      }
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await systemSettingsData();
      await getDDValues();
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleDropDown = (event) => {
    const selectedValue = parseInt(event.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1);
  };

  const { userProfileState } = useUserCapability();
  const userVsCapability = userProfileState.userVsCapability;
  const navigate = useNavigate();
  const [viewBag, setViewBag] = useState(0);

  const location1 = useLocation();
  const userSideMenu = location1?.state?.menuId;
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
    if (Array.isArray(userVsCapability) && userVsCapability.length > 0) {
      let menuFilter = userVsCapability.filter(
        (menu) => menu.MstMenuId == userSideMenu
      );
      setViewBag(menuFilter[0]?.ViewPermission);
    }
  }, [navigate]);

  const handleSearchInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
    handleSearch(inputValue);
    setCurrentPage(1);
  };

  const handleSearch = (input) => {
    const filtered = records.filter((item) => {
      const matchFound = header.some((data) => {
        const userDataKey = data.key;
        const userDataValue = item[userDataKey];

        if (
          typeof userDataValue === "string" &&
          userDataValue.toLowerCase().includes(input.toLowerCase())
        ) {
          return true;
        }
        return false;
      });

      return matchFound;
    });

    setSearchData(filtered);
  };

  return (
    <div className={loading ? "flex justify-center items-center h-full" : ""}>
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <div className="loader"></div>
        </div>
      ) : (
        <div>
          <div className={mainTable.headerTitle}>
            <div className={mainTable.gridTableHeader}>{title}</div>
          </div>
          {/* mobile search */}
          <div className="relative mt-1 md:hidden">
            <div className={mainTable.searchIconPosition}>
              <svg
                className={mainTable.searchIconSvg}
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              className={mainTable.searchInputBox}
              placeholder="Search for items"
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
          <div className="justify-between flex items-center">
            <div className={mainTable.searchAdd}>
              <DropDown
                classDiv="md:mt-1 mt-0 gap-2 flex items-center justify-between md:items-baseline"
                Class={mainTable.dropDownRecords}
                ClassLabel="hidden md:block"
                title="Rows Per Page:"
                options={bindDDValues}
                placeholder="Select"
                name="ddValues"
                selectedOption={itemsPerPage}
                controlFunc={handleDropDown}
              />
              <div className="hidden md:block relative mt-1">
                <div className={mainTable.searchIconPosition}>
                  <svg
                    className={mainTable.searchIconSvg}
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  className={mainTable.searchInputBox}
                  placeholder="Search for items"
                  value={searchInput}
                  onChange={handleSearchInputChange}
                />
              </div>
            </div>
            <div className="flex gap-1.5 self-end m-1.5">
              <button
                type="button"
                className={mainTable.addButton}
                onClick={handleExport}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="25"
                  height="20"
                >
                  <path d="M21.17 3.25q.33 0 .59.25.24.24.24.58v15.84q0 .34-.24.58-.26.25-.59.25H7.83q-.33 0-.59-.25-.24-.24-.24-.58V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.08q0-.34.24-.58.26-.25.59-.25M7 13.06l1.18 2.22h1.79L8 12.06l1.93-3.17H8.22L7.13 10.9l-.04.06-.03.07q-.26-.53-.56-1.07-.25-.53-.53-1.07H4.16l1.89 3.19L4 15.28h1.78m8.1 4.22V17H8.25v2.5m5.63-3.75v-3.12H12v3.12m1.88-4.37V8.25H12v3.13M13.88 7V4.5H8.25V7m12.5 12.5V17h-5.62v2.5m5.62-3.75v-3.12h-5.62v3.12m5.62-4.37V8.25h-5.62v3.13M20.75 7V4.5h-5.62V7z" />
                </svg>
                Excel
              </button>
            </div>
          </div>

          <ReportTableRow
            className={mainTable.table}
            isGenderBased={isGenderBased}
            tableHeight={tableHeight}
            headerData={header}
            tableData={searchData.length > 0 ? searchData : records}
            onViewGrid={handleAction ? handleAction : ""}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            viewBag={viewBag}
            onSchoolView={handleSchoolView ? handleSchoolView : ""}
          />

          <div className={mainTable.submitCancelMainDiv}>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              className={mainTable.submitButton}
            >
              Previous Page
            </button>
            <label>
              {currentPage} out of{" "}
              {Math.ceil(searchData?.length / itemsPerPage)}
            </label>
            <button
              onClick={() => {
                setCurrentPage(currentPage + 1);
              }}
              disabled={currentPage >= records.length / itemsPerPage}
              className={mainTable.cancelButton}
            >
              Next Page
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportRowRowPage;
